import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Flame, Plus } from 'lucide-react';
import { BowtieNode } from '../bowtie.types';

export const ThreatNode: React.FC<{
  data: BowtieNode & { onAddBarrier?: (threat: BowtieNode) => void };
}> = memo(({ data }) => {
  return (
    <div
      style={{
        background: '#fff7ed',
        border: '2px solid #ea580c',
        borderRadius: '12px',
        padding: '12px 16px',
        width: '240px',
        minHeight: '108px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        boxShadow: '0 4px 6px -1px rgba(234, 88, 12, 0.1)',
        position: 'relative',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#c2410c', fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          <Flame size={14} />
          <span>THREAT / CAUSE</span>
        </div>
        {data.onAddBarrier && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              data.onAddBarrier?.(data);
            }}
            title="Add a prevention barrier for this threat"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '3px',
              padding: '2px 7px',
              fontSize: '10px',
              fontWeight: 700,
              borderRadius: '6px',
              background: '#ffedd5',
              border: '1px solid #fdba74',
              color: '#c2410c',
              cursor: 'pointer',
              transition: 'all 0.15s ease',
            }}
          >
            <Plus size={11} />
            Barrier
          </button>
        )}
      </div>

      <div style={{ fontWeight: 600, fontSize: '13px', color: '#7c2d12', marginTop: '6px', lineHeight: 1.3 }}>
        {data.label}
      </div>

      <Handle id="right" type="source" position={Position.Right} style={{ background: '#ea580c', width: 8, height: 8 }} />
    </div>
  );
});
